import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import aboutImg from '../assets/img/about-as-networks.png';
import missionImg from '../assets/img/our-mission.png';
import teamImg from '../assets/img/consulting-services.avif';
import valuesImg from '../assets/img/our-values.png';

function AboutPage() {
  return (
    <>
      <div className="hero-header sec-padding inner-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <h1>About Us</h1>
              <p>The team behind Netwatch and trusted DDI consulting services</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <img src={aboutImg} alt="About NexVeda Networks" />
            </div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Our Story</span>
                <h2 className="head-main after-border">About NexVeda Networks</h2>
                <p>
                  NexVeda Networks was founded with a vision to empower organizations by providing top-notch
                  tools and consultancy for DNS, DHCP, and IP Address Management (DDI) systems. After years
                  of consulting with enterprises worldwide, we built <b>Netwatch</b> — the network monitoring
                  platform we wished we'd had from day one. Today, we combine our product with deep DDI
                  expertise to help companies optimize their network infrastructures.
                </p>
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding colum-reverse" style={{ background: '#f8f9fc' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Why We Exist</span>
                <h2 className="head-main after-border">Our Mission</h2>
                <p>
                  Our mission is to deliver powerful, intuitive tools and expert support that enable organizations
                  to manage their DDI environments more effectively. Through Netwatch and our consulting services,
                  we strive to simplify complex network challenges and drive operational excellence.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <img src={missionImg} alt="Our Mission" />
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <img src={teamImg} alt="Our Team" />
            </div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Meet the Experts</span>
                <h2 className="head-main after-border">Our Team</h2>
                <p>
                  Our team comprises seasoned professionals with over a decade of experience in
                  DNS, DHCP, and DDI solutions. We have a proven track record of working with leading DDI
                  products <b>(Palo Alto, Checkpoint &amp; FortiGate)</b> and delivering impactful results. Our experts
                  are the same people who built Netwatch — engineers and consultants who understand your challenges firsthand.
                </p>
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding colum-reverse" style={{ background: '#f8f9fc' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">What Drives Us</span>
                <h2 className="head-main after-border">Our Values</h2>
                <h3 style={{ marginTop: '20px' }}>Integrity</h3>
                <p>We operate with transparency and honesty, ensuring that our products and
                  recommendations are always in your best interest.</p>
                <h3>Excellence</h3>
                <p>We are dedicated to building the highest quality products and delivering
                  outstanding service, leveraging our deep domain expertise.</p>
                <h3>Collaboration</h3>
                <p>We believe in working closely with our customers to understand their needs
                  and build solutions that drive real value.</p>
              </div>
            </div>
            <div className="col-lg-5">
              <img src={valuesImg} alt="Our Values" />
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="cta-section text-center">
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <h2>Want to Join Our Team?</h2>
          <p>We're always looking for talented people who are passionate about network infrastructure and building great products.</p>
          <div className="banner-buttons" style={{ justifyContent: 'center' }}>
            <Link to="/product" className="btn-primary-gradient">Explore Netwatch</Link>
            <Link to="/services" className="btn-outline-white">Our Services</Link>
          </div>
        </div>
      </div>

      <ContactForm
        earlyAccess={true}
        title="Apply for Early Access"
        description="Our MVP launches July–August 2026. We're selecting 5 pilot customers to test Netwatch and help shape its future. Fill out the form below and our team will be in touch."
      />
    </>
  );
}

export default AboutPage;
